import { Navigate, Route, Routes, useParams } from "react-router-dom";
import { LocaleLayout, RootRedirect } from "./i18n/LocaleLayout.jsx";
import { OidcCallback, RequireAuth, RequireMembership, WorkspaceLayout } from "./layouts.jsx";
import { OIDC_CALLBACK_PATH } from "./auth.js";
import BillingReturn from "./pages/BillingReturn.jsx";
import Dashboard from "./pages/Dashboard.jsx";
import InvestigationDetail from "./pages/InvestigationDetail.jsx";
import Investigations from "./pages/Investigations.jsx";
import JobView from "./pages/JobView.jsx";
import Login from "./pages/Login.jsx";
import NewInvestigation from "./pages/NewInvestigation.jsx";
import NotFound from "./pages/NotFound.jsx";
import Onboarding from "./pages/Onboarding.jsx";
import Settings from "./pages/Settings.jsx";
import { SessionProvider } from "./session.jsx";

function InvestigationRoute() {
  const { id } = useParams();
  return <InvestigationDetail key={id} />;
}

export default function App() {
  return (
    <SessionProvider>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path={OIDC_CALLBACK_PATH} element={<OidcCallback />} />
        <Route path="/:locale" element={<LocaleLayout />}>
          <Route path="login" element={<Login />} />
          <Route element={<RequireAuth />}>
            <Route path="onboarding" element={<Onboarding />} />
            <Route path="billing" element={<BillingReturn />} />
            <Route
              element={
                <RequireMembership>
                  <WorkspaceLayout />
                </RequireMembership>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Navigate to=".." replace />} />
              <Route path="investigations" element={<Investigations />} />
              <Route path="investigations/new" element={<NewInvestigation />} />
              <Route path="investigations/:id" element={<InvestigationRoute />} />
              <Route path="jobs/:jobId" element={<JobView />} />
              <Route path="settings" element={<Settings />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Route>
        </Route>
      </Routes>
    </SessionProvider>
  );
}
